import {i18nSetMessageParams} from "./misc";

/**
 Add or change the first child text node of the specified document element.
 For example given the span: <span id="mySpan"></span>
 Calling: setElementText(document.getElementById("mySpan"), "Hello World");
 Will insert a text node into the span with the text "Hello World".  If the node
 already begins with a text node its text will be changed.*/
export function setElmText(elm, text) {
    if (!elm)
        throw 'setElmText: elm parameter is null or undefined (text was "' + text + '")';

    //make sure text parameter is a string
    text = String(text);

    let TEXT_NODE = 3;
    if (elm.hasChildNodes()) {
        //first child is a text node?
        if (elm.firstChild.nodeType == TEXT_NODE)
            elm.firstChild.nodeValue = text;
        else {
            //prepend a text node if the text is not empty
            if (text.length > 0)
                elm.insertBefore(document.createTextNode(text), elm.firstChild);
        }
    } else {
        //append a text node if the text is not empty
        if (text.length > 0)
            elm.appendChild(document.createTextNode(text));
    }
}

/**
 A backwards compatibility alias for setElmText.
 */
export function setElementText(elm, text) {
    setElmText(elm, text);
}

/**a convenience function*/
export function setElmTextById(elmName, text) {
    setElmText(document.getElementById(elmName), text);
}

/**get the text of an element.
 *  @param elm
 @param recursive optional.  Pass true to get the full raw text within this element.
 This is handy if the given element contain more markup.
 */
export function getElmText(elm, recursive) {
    if (!elm)
        throw "elm is undefined";

    let text;
    if (elm.firstChild)
        text = String(elm.firstChild.nodeValue);
    else  //the element has no children - return an empty string
        text = "";

    if (recursive) {
        for (let i = 0; i < elm.childNodes.length; i++)
            text += ' ' + getElmText(elm.childNodes[i], true);
    }

    return text;
}

export function getSelectedOption(selectElm) {
    let count = 0;
    let index = 0;

    if ((selectElm)&&(selectElm.options)) {
        for (let i = 0; i < selectElm.options.length; i++) {
            if (selectElm.options[i].selected) {
                count++;
                index = i;
            }
        }
    }

    if (count === 1) {
        return selectElm.options[index];
    }

    return null;
}

export function selectOption(selectElm, optionValue) {
    optionValue = String(optionValue);
    for (let i = 0; i < selectElm.options.length; i++)
        selectElm.options[i].selected = selectElm.options[i].value == optionValue;
}

/*
 This function sets the enabled state of the specified button.  Valid buttons are:
 button-add
 button-remove
 button-hide
 button-copy
 button-cut
 button-paste
 */
export function CA_enableButton(buttonBaseName, enabled) {
    let btnOn = document.getElementById(buttonBaseName);
    let btnOff = document.getElementById(buttonBaseName + "-off");

    if (btnOn && btnOff) {
        if (enabled) {
            btnOn.style.display = "inline-block";
            btnOff.style.display = "none";
        } else {
            btnOn.style.display = "none";
            btnOff.style.display = "inline-block";
        }
    }
}

export function showVdxNotice(noticeId, show) {
    const elm = document.getElementById(noticeId);
    if (!elm) {
        console.error('Failed to find noticeId: ' + noticeId);
        return;
    }

    if (show !== (elm.style.display !== 'none'))
        elm.style.display = show ? 'table' : 'none';
}

/** helper to show or hide an icon link */
export function showIconLink(linkId, show) {
    const elm = document.getElementById(linkId);
    if (elm) {
        if (show)
            elm.style.display = "inline";
        else
            elm.style.display = "none";
    }
}

export function doBulkChecked() {
    const chkBulk = document.getElementById('chkBulk');
    if (chkBulk) {
        chkBulk.addEventListener('change', function (evt) {
            const subject = document.getElementById('formSubject');
            if (evt.target.checked) {
                //save original text
                if (!GlobalEnt.origFormSubject) {
                    GlobalEnt.origFormSubject = getElmText(subject);
                }
                const str = i18nSetMessageParams(i18n.common.bulk_selectedItems);
                setElementText(subject, str);
            } else {
                setElementText(subject, GlobalEnt.origFormSubject);
            }
        });
    }
}

export const applyEventsToBtn = (btn, callback) => {
    const events = ['click', 'touchstart'];
    events.forEach(function(name) {
        btn.addEventListener(name, (e) => {
            callback(e);
        }, true);
    });
}

export function removeAllChildrenOfElement(element) {
    if (!element) {
        return;
    }
    while (element.firstChild) {
        element.removeChild(element.lastChild);
    }
}

export function createListElement(textArr) {
    const ulEl = document.createElement('ul');
    textArr.forEach((text) => {
        const liEl = document.createElement('li');
        liEl.innerText = text;
        ulEl.appendChild(liEl);
    });
    return ulEl;
}